import { Component, OnInit, Input, ViewChild } from '@angular/core';

// Plugin
import { DeviceDetectorService } from 'ngx-device-detector';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

// jquery 
declare var $: any;

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styles: [
  ]
})
export class SubHeaderComponent implements OnInit {

  @ViewChild('slickModalSubHead') slickModalSubHead: SlickCarouselComponent;
  @Input() dataSub;
  isDesktop;
  slideSubHeaderConfig = {
    "slidesToShow": 2, 
    "autoplay": false,
    "arrows": false,
    "slidesToScroll": 2,
    "variableWidth": true,
    "infinite": false,
    // "draggable": false
  };
  dataSubHeader;

  constructor(private deviceService: DeviceDetectorService) { }

  ngOnInit(): void {
    this.isDesktop = this.deviceService.isDesktop();
    
    $(document).on('wheel', 'body', () => {
        let index = $('.sub-header .slide .current').attr('id');
        if(index) {
          this.slickModalSubHead.slickGoTo(index);
        }
    });

    $(document).on('wheel', '.sub-header', () => {
      $('.sub-header').bind('mousewheel DOMMouseScroll', (e) => { 
        if (e.originalEvent.deltaY < 0) {
          this.slickModalSubHead.slickPrev();
        } else {
          this.slickModalSubHead.slickNext();
        }
        return false; 
      });
    });
  }

}
